import React from 'react'
import { notificationOptions } from '../../../../../common/options'
import { Maybe, UserRole } from '../../../../../common/types'
import { FormSubGroup, FormSubGroupWrapper, Section, SectionColumn } from '../../../../../components/layout'
import { TowingTypeInput, StationInput, OperatorInput, SelectInput } from '../../../../../components/layout/form/input'
import { Notifications } from '../../../../Parameters/types'
import { acceptedRoles } from '../../../../TowingOrderPage/AddTowingOrder/TowingOrderSettingsForm'
import { messages } from './messages'
import { formatMessageSafe, translateInputOptions } from '../../../../../util/translateInputOptions'
import { useIntl } from 'react-intl'

interface TowingRecordSettingsProps {
  isAl?: boolean
  disableOperator?: boolean
  notificationSettings?: Maybe<Notifications>
  userRole?: Maybe<UserRole>
  isSos?: boolean
}

const TowingRecordSettingsIntl: React.FunctionComponent<TowingRecordSettingsProps> = ({
  notificationSettings,
  userRole,
  isSos,
  disableOperator = true,
  isAl = false,
}) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  if (!isSos && notificationSettings && notificationSettings.enabled && userRole && acceptedRoles.includes(userRole)) {
    return (
      <FormSubGroupWrapper>
        <FormSubGroup>
          <Section marginBottom="0" margin="0.5rem 0" columns={2}>
            <SectionColumn>
              <TowingTypeInput label={formatMessage(messages.settings_type)} name="label" isAl={isAl} disabled={isAl} />
            </SectionColumn>
            <SectionColumn>
              <StationInput label={formatMessage(messages.settings_station)} name="stationId" />
            </SectionColumn>
          </Section>
          <Section columns={2}>
            <SectionColumn>
              <OperatorInput
                label={formatMessage(messages.settings_operator)}
                name="operatorId"
                disabled={disableOperator}
                clearable
                placeholder={formatMessage(messages.settings_operatorPlaceholder)}
              />
            </SectionColumn>
            <SectionColumn>
              <SelectInput
                label={formatMessage(messages.settings_notificationMethod)}
                name="notificationMethod"
                placeholder={formatMessage(messages.settings_notificationMethodPlaceholder)}
                options={translateInputOptions(notificationOptions, formatMessage)}
              />
            </SectionColumn>
          </Section>
        </FormSubGroup>
      </FormSubGroupWrapper>
    )
  }

  return (
    <FormSubGroupWrapper>
      <FormSubGroup>
        <Section marginBottom="0" margin="0.5rem 0" columns={3}>
          <SectionColumn>
            <TowingTypeInput label={formatMessage(messages.settings_type)} name="label" isAl={isAl} disabled={isAl} />
          </SectionColumn>
          <SectionColumn>
            <StationInput label={formatMessage(messages.settings_station)} name="stationId" />
          </SectionColumn>
          <SectionColumn>
            <OperatorInput
              label={formatMessage(messages.settings_operator)}
              name="operatorId"
              disabled={disableOperator}
            />
          </SectionColumn>
        </Section>
      </FormSubGroup>
    </FormSubGroupWrapper>
  )
}

export const TowingRecordSettings = TowingRecordSettingsIntl
